import { Button, Col, Divider, Modal, Row, Space, Tag, Typography } from 'antd';
import React, { FC, useCallback, useEffect, useState } from 'react';
import {
  ArrowRightOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  RetweetOutlined,
} from '@ant-design/icons';
import Link from 'antd/lib/typography/Link';
import { UserAvatar } from '../../atoms/UserAvatar';
import './UpdatesCard.less';
import { useConnection, useEvents, useUserInfo } from '../../../connection/Application';
import Title from 'antd/lib/typography/Title';
import Form from '../../../form/Form';
import ReactHtmlParser from '../../../utils/SafeHtmlParser';
import dayjs from 'dayjs';
const { Text } = Typography;

const { CheckableTag } = Tag;

export type Props = {
  id: number;
  parentId?: number;
  type: 'objective' | 'keyResult';
  disable?: boolean;
};
const tagsData = [
  { id: 'All', value: 'All' },
  { id: 'Updates', value: 'History' },
  { id: 'Comments', value: 'Comments' },
  { id: 'History', value: 'Updates' },
  { id: 'Evaluations', value: 'Evaluations' },
];

const regex = /(<([^>]+)>)/gi;

const UpdatesCard: FC<Props> = (props) => {
  const connection = useConnection();
  const [form] = Form.useForm();
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [showCommentButton, setShowCommentButton] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [comment, setComment] = useState<string>();
  const [type, setType] = useState<string>('Comments');
  const user = useUserInfo();
  const events = useEvents();

  const getDetails = useCallback(async () => {
    const res = await connection.get(`value-change/${props.type}/${props.id}`, {
      page: 1,
      limit: page * 10,
      valueChangeType: type,
    });
    const array = res.body.valueChange.map((item: any) => {
      const newTime = dayjs(+item.time * 1000).format('h:mm a');
      return { ...item, time: newTime };
    });
    const tempArr = [...array];

    console.log(tempArr);
    setTotal(res.body.total);
    setData(tempArr);
  }, [connection, page, props.id, props.type, type]);

  useEffect(() => {
    let isMounted = true; // note mutable flag
    connection
      .get(`value-change/${props.type}/${props.id}`, {
        page,
        limit: 10,
        valueChangeType: type,
      })
      .then((res) => {
        if (isMounted) {
          const array = res.body.valueChange.map((item: any) => {
            const newTime = dayjs(+item.time * 1000).format('h:mm a');
            return { ...item, time: newTime };
          });
          const tempArr = [...data, ...array];

          setTotal(res.body.total);
          console.log(tempArr);
          setData(tempArr);
        }
      });
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [connection, page, props.id, props.type, type]);

  useEffect(() => {
    const handler = () => {
      setData([]);
      setPage(1);
      getDetails();
    };
    events.on('VALUE_CHANGE_RELOAD', handler);
    return () => {
      events.off('VALUE_CHANGE_RELOAD', handler);
    };
  }, [events, getDetails]);

  const [showContent, setShowContent] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);

  const createComment = useCallback(
    (l: string) => {
      const newData = {
        time: dayjs().unix().toString(),
        date: dayjs().format('MMM DD, YYYY'),
        userId: user?.userId,
        type: props.type,
        keyResultId: props.type === 'keyResult' ? props.id : undefined,
        goalId: props.type === 'objective' ? props.id : props.parentId,
        comment: l,
        valueChangeType: 'Comments',
      };
      if (l !== '') {
        setLoading(true);
        connection
          .post(`value-change`, { data: newData })
          .then(async () => {
            setComment('');
            await getDetails();
            setShowContent(true);
            setLoading(false);
            // const newTime = dayjs(+newData.time * 1000).format('h:mm a');
            // setData([{ ...newData, user, time: newTime }, ...data]);
          })
          .catch((e) => {
            console.log(e);
            setLoading(false);
          })
          .finally(() => {
            form.resetFields();
            setShowCommentButton(false);
          });
      }
    },
    [connection, form, getDetails, props.id, props.parentId, props.type, user?.userId],
  );

  const deleteComment = useCallback(
    (id: number) => {
      Modal.confirm({
        title: 'Delete Comment',
        icon: <ExclamationCircleOutlined />,
        content: 'Are you sure delete to this Comment?',
        okText: 'Delete',
        okType: 'danger',
        onOk() {
          setData([]);
          setTotal(0);
          connection
            .delete(`value-change`, { id })
            .then(async () => {
              await getDetails();
              // setData([...data.filter((x) => x.id !== id)]);
            })
            .catch((e) => console.log(e));
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    [connection, getDetails],
  );

  return (
    <div>
      <Row style={{ alignItems: 'center', marginTop: 20 }}>
        <Space>
          <Title level={5}>Activity</Title>
          <RetweetOutlined style={{ fontSize: 20 }} />
        </Space>
        <div style={{ marginLeft: 10 }}>
          {tagsData.map((tag) => (
            <CheckableTag
              key={tag.id}
              checked={tag.id === type}
              onChange={(checked) => {
                if (checked) {
                  console.log(tag.id);
                  setType(tag.id);
                  setData([]);
                  setPage(1);
                  setTotal(0);
                }
              }}>
              {tag.value}
            </CheckableTag>
          ))}
        </div>
      </Row>
      <Divider orientation="left" style={{ marginTop: 0, marginBottom: 0 }} />
      {props.disable !== true && type === 'Comments' && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', margin: '20px 0 10px 0', width: '100%' }}>
            <div style={{ width: '32px !important', height: 32 }}>
              <UserAvatar src={user?.image} />
            </div>
            <div style={{ marginLeft: 10, flex: 1, marginBottom: -15 }}>
              <Form layout={'vertical'} form={form} onFinish={(l) => createComment(l.comment)}>
                <Form.Items
                  schema={[
                    {
                      id: 'comment',
                      name: 'Add Comment',
                      type: 'richText',
                      props: {
                        autosize: { minRows: 8, maxRows: 12 },
                        maxLength: 10000,
                        onFocus: () => {
                          setShowCommentButton(true);
                        },
                      },
                      options: {
                        rules: [
                          // { required: true, whitespace: true, message: 'Comment is required' },
                          { max: 10000, message: 'Only 10000 characters are allowed.' },
                        ],
                      },
                    },
                  ]}
                />
                {showCommentButton && (
                  <Form.Item>
                    <Space>
                      <Button
                        style={{
                          display: showCommentButton ? 'flex' : 'none',
                          justifyContent: 'center',
                        }}
                        disabled={loading}
                        type={'primary'}
                        onClick={form.submit}>
                        Save
                      </Button>
                      <Button
                        style={{
                          display: showCommentButton ? 'flex' : 'none',
                          justifyContent: 'center',
                        }}
                        onClick={() => {
                          setComment('');
                          form.resetFields();
                          setShowCommentButton(false);
                        }}>
                        cancel
                      </Button>
                    </Space>
                  </Form.Item>
                )}
              </Form>
            </div>
          </div>
        </div>
      )}
      <Link onClick={() => setShowContent(!showContent)}>
        <Space className="div_hover">
          <Text>Show Activities</Text>
          {!showContent ? (
            <CaretDownOutlined style={{ marginTop: 7, color: 'rgba(0,0,0,0.7)' }} />
          ) : (
            <CaretUpOutlined style={{ marginTop: 7, color: 'rgba(0,0,0,0.7)' }} />
          )}
        </Space>
      </Link>
      {showContent &&
        data.map((item, key) => {
          if (item.valueChangeType === 'History') {
            return (
              <div key={key} className="borderBox">
                <Row>
                  <Space>
                    <UserAvatar src={item?.user?.image} />
                    <Text strong>{item?.user?.firstName + ' ' + item?.user?.lastName}</Text>
                    <Text type="secondary">{item.date + ' ' + item.time}</Text>
                  </Space>
                </Row>
                {props.type === 'objective' && (
                  <Space style={{ marginTop: 10 }}>
                    <Text type="secondary">{`Updated`}</Text>
                    <Text>{item?.keyResult?.title}</Text>
                  </Space>
                )}
                <Row style={{ alignItems: 'center', marginTop: 5 }}>
                  <Space>
                    <Text>{item?.beforeValue + ' '}</Text>
                    <Text>{item?.keyResultType !== 'Open/Done' && item?.unit}</Text>
                    {item?.beforeStatus == 'Pending' ? (
                      <Tag
                        style={{ height: 25, alignItems: 'center', display: 'flex' }}
                        color="blue">
                        Pending
                      </Tag>
                    ) : item?.beforeStatus == 'Not Started' ? (
                      <Tag style={{ height: 25, alignItems: 'center', display: 'flex' }} color="">
                        Not Started
                      </Tag>
                    ) : item?.beforeStatus == 'Ontrack' ? (
                      <Tag
                        style={{ height: 25, alignItems: 'center', display: 'flex' }}
                        color="yellow">
                        Ontrack
                      </Tag>
                    ) : item?.beforeStatus == 'On-hold' ? (
                      <Tag
                        style={{ height: 25, alignItems: 'center', display: 'flex' }}
                        color="cyan">
                        On-hold
                      </Tag>
                    ) : item?.beforeStatus == 'Offtrack' ? (
                      <Tag
                        style={{ height: 25, alignItems: 'center', display: 'flex' }}
                        color="red">
                        Offtrack
                      </Tag>
                    ) : (
                      <Tag
                        style={{ height: 25, alignItems: 'center', display: 'flex' }}
                        color="green">
                        Completed
                      </Tag>
                    )}
                    <ArrowRightOutlined />
                    <Text>{item?.updatedValue + ' '}</Text>
                    <Text>{item?.keyResultType !== 'Open/Done' && item?.unit}</Text>
                    {item?.updatedStatus == 'Pending' ? (
                      <Tag
                        style={{ height: 25, alignItems: 'center', display: 'flex' }}
                        color="blue">
                        Pending
                      </Tag>
                    ) : item?.updatedStatus == 'Not Started' ? (
                      <Tag style={{ height: 25, alignItems: 'center', display: 'flex' }} color="">
                        Not Started
                      </Tag>
                    ) : item?.updatedStatus == 'Ontrack' ? (
                      <Tag
                        style={{ height: 25, alignItems: 'center', display: 'flex' }}
                        color="yellow">
                        Ontrack
                      </Tag>
                    ) : item?.updatedStatus == 'Offtrack' ? (
                      <Tag
                        style={{ height: 25, alignItems: 'center', display: 'flex' }}
                        color="red">
                        Offtrack
                      </Tag>
                    ) : item?.beforeStatus == 'On-hold' ? (
                      <Tag
                        style={{ height: 25, alignItems: 'center', display: 'flex' }}
                        color="cyan">
                        On-hold
                      </Tag>
                    ) : (
                      <Tag
                        style={{ height: 25, alignItems: 'center', display: 'flex' }}
                        color="green">
                        Completed
                      </Tag>
                    )}
                  </Space>
                </Row>

                {item?.comment && (
                  <>
                    <Row style={{ marginTop: 10 }}>
                      <Text>Comment</Text>
                    </Row>
                    <div
                      style={{
                        marginTop: 10,
                        border: '1px solid rgba(0, 0, 0, 0.18)',
                        padding: '5px',
                      }}>
                      <Text>{ReactHtmlParser(item?.comment)}</Text>
                    </div>
                  </>
                )}
              </div>
            );
          } else if (item.valueChangeType === 'Comments') {
            return (
              <div key={key} className="borderBox">
                <Row>
                  <Space>
                    <UserAvatar src={item?.user?.image} />
                    <Text strong>{item?.user?.firstName + ' ' + item?.user?.lastName}</Text>
                    <Text type="secondary">{item.date + ' ' + item.time}</Text>
                  </Space>
                </Row>
                {props.type === 'objective' && (
                  <Space style={{ marginTop: 10 }}>
                    <Text type="secondary">{`Added Comment on`}</Text>
                    <Text>{item?.keyResult?.title}</Text>
                  </Space>
                )}
                {item?.comment && (
                  <>
                    <Row style={{ marginTop: 10, justifyContent: 'space-between' }}>
                      <Text>Comment</Text>
                      {item.delete && <Tag color={'red'}>Deleted</Tag>}
                    </Row>
                    <div
                      style={{
                        marginTop: 10,
                        border: '1px solid rgba(0, 0, 0, 0.18)',
                        padding: '5px',
                      }}>
                      <Text>
                        {item?.comment && !!item?.comment?.replace(regex, '').length
                          ? ReactHtmlParser(item?.comment)
                          : ''}
                      </Text>
                    </div>
                    {user?.userId === item.user.id && !item.delete && (
                      <Button
                        type="default"
                        danger
                        style={{
                          color: 'red',
                          border: 'red 1px solid',
                          padding: '10px 20px',
                          margin: 10,
                          width: 120,
                          height: 45,
                          cursor: 'pointer',
                        }}
                        onClick={() => deleteComment(item.id)}
                        icon={<DeleteOutlined style={{ marginRight: 5 }} />}>
                        Delete
                      </Button>
                    )}
                  </>
                )}
              </div>
            );
          } else if (item.valueChangeType === 'Evaluations') {
            return (
              <div key={key} className="borderBox">
                <Row>
                  <Space>
                    <UserAvatar src={item?.user?.image} />
                    <Text strong>{item?.user?.firstName + ' ' + item?.user?.lastName}</Text>
                    <Text type="secondary">{item.date + ' ' + item.time}</Text>
                  </Space>
                </Row>
                {item.unit === 'user' && (
                  <Row style={{ marginTop: 10 }}>
                    <Space>
                      <Text type="secondary">{`Updated Self Evaluation Mark to`}</Text>
                      <Text type="secondary">{item?.updatedValue}</Text>
                    </Space>
                  </Row>
                )}
                {item.unit === 'supervisor' && (
                  <Col>
                    <Row style={{ marginTop: 10 }}>
                      <Text type="secondary">Updated Supervisor Evaluation Mark</Text>
                    </Row>
                    <Space>
                      {item?.beforeValue !== null && (
                        <>
                          <Text type="secondary">{!item?.beforeValue ? 0 : item?.beforeValue}</Text>
                          <ArrowRightOutlined />
                        </>
                      )}

                      <Text type="secondary">{item?.updatedValue}</Text>
                    </Space>
                  </Col>
                )}
                {item?.comment && (
                  <>
                    <Row style={{ marginTop: 10 }}>
                      <Text>Comment</Text>
                    </Row>
                    <div
                      style={{
                        marginTop: 10,
                        border: '1px solid rgba(0, 0, 0, 0.18)',
                        padding: '5px',
                      }}>
                      {ReactHtmlParser(item?.comment)}
                    </div>
                  </>
                )}
              </div>
            );
          } else if (item.valueChangeType === 'Updates') {
            return (
              <div key={key} className="borderBox">
                <Row>
                  <Space>
                    <UserAvatar src={item?.user?.image} />
                    <Text strong>{item?.user?.firstName + ' ' + item?.user?.lastName}</Text>
                    <Text type="secondary">{item.date + ' ' + item.time}</Text>
                  </Space>
                </Row>
                {props.type === 'objective' && item.type === 'keyResult' ? (
                  <Space>
                    <Text type="secondary">Updated {item.unit} on</Text>
                    <Text>{item?.keyResult?.title}</Text>
                  </Space>
                ) : (
                  <Text type="secondary">Updated {item.unit}</Text>
                )}
                {item.unit === 'Status' ? (
                  <Space>
                    <Tag
                      style={{ height: 25, alignItems: 'center', display: 'flex' }}
                      color={
                        item.beforeValue === 'Ontrack'
                          ? 'yellow'
                          : item?.status === 'On-hold'
                          ? 'cyan'
                          : item.beforeValue === 'Offtrack'
                          ? 'red'
                          : item.beforeValue === 'Completed'
                          ? 'green'
                          : ''
                      }>
                      {item.beforeValue}
                    </Tag>
                    <Text>To</Text>
                    <Tag
                      style={{ height: 25, alignItems: 'center', display: 'flex' }}
                      color={
                        item.updatedValue === 'Ontrack'
                          ? 'yellow'
                          : item?.status === 'On-hold'
                          ? 'cyan'
                          : item.updatedValue === 'Offtrack'
                          ? 'red'
                          : item.updatedValue === 'Completed'
                          ? 'green'
                          : ''
                      }>
                      {item.updatedValue}
                    </Tag>
                  </Space>
                ) : (
                  <Space>
                    <Text type="secondary">{item.beforeValue}</Text>
                    <Text>To</Text>
                    <Text type="secondary">{item.updatedValue}</Text>
                  </Space>
                )}
              </div>
            );
          }
        })}
      {total / (page * 10) > 1 && showContent && (
        <Link
          onClick={() => {
            setData(data.slice(0, 10 * page));
            setPage(page + 1);
          }}>
          <Space className="div_hover">
            <Text>Load More ...</Text>
          </Space>
        </Link>
      )}
    </div>
  );
};

export default UpdatesCard;
